// 商品列表
import RedemptionItemComponent from '@/components/index/RedemptionItemComponent'; // 商品元件

interface RedemptionListProps {
    items: any[];
}

const RedemptionList = ({ items = [] }: RedemptionListProps) => {
    return (
        <div className="grid grid-cols-1 lg:grid-cols-2 mb-7 gap-1.5 lg:gap-3">
            {items.map((item: any, index: number) => (
                <RedemptionItemComponent key={item?.code ?? index} item={item} />
            ))}
        </div>
    );
};

export default RedemptionList;
